<template>
    <div>
        <div @click="triggerClick">
            <el-button v-if="!$slots.default" type="primary">围栏绘制</el-button>
            <slot></slot>
        </div>
        <Dialog v-model="visible" title="围栏绘制" :padding="0" :footer="false" width="big">
            <div class="box">
                <div class="map" ref="map"></div>
                <div class="layer">
                    <template v-if="!isDrawing">
                        <el-select v-model="fence.type" placeholder="围栏类型" :clearable="false" class="w-[120px]">
                            <el-option label="圆形" value="circle"></el-option>
                            <el-option label="多边形" value="polygon"></el-option>
                        </el-select>
                        <el-autocomplete v-model="searchVal" class="w-[200px] mr-[10px]" :fetch-suggestions="querySearch"
                            :trigger-on-focus="false" placeholder="搜索围栏绘制区域" prefix-icon="el-icon-search"
                            @select="handleSelect">
                            <template slot-scope="{ item }">
                                <div class="text-sm text-[#333] mt-[10px]">{{ item.name }}</div>
                                <div class="text-xs text-[#888] mb-[10px]">{{ item.address }}</div>
                            </template>
                        </el-autocomplete>
                        <el-button type="primary" @click="doDraw">开始绘制</el-button>
                        <el-button type="primary" plain @click="visible = false">关闭</el-button>
                    </template>
                    <template v-else>
                        <div class="flex-1 pl-[15px] pr-[15px] text-hui">请先绘制围栏区域，再设置预警规则</div>
                        <el-button type="primary" @click="confirm">完成绘制</el-button>
                        <el-button type="primary" plain @click="doClear">清空</el-button>
                    </template>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import lodash from 'lodash';

export default {
    name: 'mapFencePrimary',
    components: {},
    model: {
        prop: 'value',
        event: 'confirm'
    },
    props: {
        value: {
            type: Object,
            default: () => { return {} }
        },
        // 点击触发栏之前的操作，返回false，可阻止打开弹层
        beforeTrigger: Function,
    },
    data() {
        return {
            visible: false,
            fence: {
                type: 'circle',
                path: [],
                center: [],
                radius: 1000,
            },
            AMap: null, // AMap实例
            mapCase: null, // 地图实例
            circle: null, // 圆形实例
            circleCase: null, // 圆形编辑实例
            polygon: null, // 多边形实例
            polygonCase: null, // 多边形编辑实例
            searchVal: '',
            autoCompleteCase: null,
            placeSearchCase: null,
            isDrawing: false,
        }
    },
    methods: {
        /**
         * 点击触发栏
         */
        triggerClick() {
            if (this.beforeTrigger && this.beforeTrigger() === false) return;
            this.doClear();
            this.visible = true;
            this.initMap();
        },
        // 完成绘制
        confirm() {
            this.fence.zoom = this.mapCase.getZoom();
            const center = this.mapCase.getCenter();
            this.fence.mapCenter = [center.lng, center.lat];
            if (this.fence.type === 'circle') {
                const opts = this.circleCase.getTarget()._opts;
                const center = opts.center;
                this.fence.radius = opts.radius;
                this.fence.center = [center.lng, center.lat];
            } else {
                const opts = this.polygonCase.getTarget()._opts;
                const path = opts.path.map(ele => {
                    return {
                        lng: ele[0],
                        lat: ele[1]
                    }
                });
                this.fence.path = path;
            }
            const clone = lodash.cloneDeep(this.fence);
            this.$emit('confirm', clone);
            this.visible = false;
        },
        // 搜索
        querySearch(val, cb) {
            this.autoCompleteCase.search(val, (status, result) => {
                if (status === 'complete') {
                    const res = result.tips.map(ele => {
                        return {
                            ...ele,
                            address: typeof ele.address === 'string' ? ele.address : ''
                        }
                    });
                    cb(res);
                } else {
                    cb([])
                }
            });
        },
        // 选择搜索结果
        handleSelect(val) {
            this.mapCase.clearMap();
            this.searchVal = val.name;
            if (val.location) {
                // 如果有具体的坐标，展示坐标点标记
                const position = val.location || {};
                const icon = new AMap.Icon({
                    image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
                    imageSize: [25, 34],
                });
                const marker = new AMap.Marker({
                    icon,
                    position,
                    title: val.name,
                    offset: new AMap.Pixel(-13, -30),
                });
                this.mapCase.add(marker);
                this.mapCase.setFitView([marker], true);
            } else {
                this.placeSearchCase.search(val.name);
            }
        },
        // 清空
        doClear() {
            this.isDrawing = false;
            this.searchVal = '';
            this.fence = this.$options.data.call(this).fence;
            if (this.circleCase) {
                this.circleCase.close();
                this.circle.destroy();
            }
            if (this.polygonCase) {
                this.polygonCase.close();
                this.polygon.destroy();
            }
        },
        // 开始绘制
        doDraw() {
            if (!this.fence.mapCenter || this.fence.mapCenter.length === 0) {
                const center = this.mapCase.getCenter();
                this.fence.mapCenter = [center.lng, center.lat];
            }
            if (this.fence.type === 'circle') {
                this.setCircle();
            } else {
                this.setPolygon();
            }
            this.isDrawing = true;
        },
        // 画多边形
        setPolygon() {
            if (this.polygonCase) {
                this.polygonCase.close();
            }
            if (this.polygon) {
                this.polygon.destroy();
            }
            const AMap = this.AMap;
            let path = this.fence.path.map(ele => {
                return [ele.lng, ele.lat];
            });
            if (!path || !path.length) {
                const lng = this.fence.mapCenter[0];
                const lat = this.fence.mapCenter[1];
                path = [
                    [lng - 0.01, lat + 0.005],
                    [lng + 0.01, lat + 0.005],
                    [lng + 0.01, lat - 0.005],
                    [lng - 0.01, lat - 0.005],
                ];
            }
            this.polygon = new AMap.Polygon({
                path, //设置多边形边界路径
                strokeColor: '#3697FF', //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 3,    //线宽
                fillColor: '#36A2FF', //填充色
                fillOpacity: 0.2, //填充透明度
                draggable: true
            });
            this.mapCase.add(this.polygon);
            this.polygonCase = new AMap.PolygonEditor(this.mapCase, this.polygon);
            this.polygonCase.open();
            if (this.fence.zoom) {
                this.mapCase.setZoomAndCenter(this.fence.zoom, this.fence.mapCenter, true);
            } else {
                this.mapCase.setFitView([this.polygon], true);
            }
        },
        // 画圆
        setCircle() {
            if (this.circleCase) {
                this.circleCase.close();
            }
            if (this.circle) {
                this.circle.destroy();
            }
            const AMap = this.AMap;
            let radius = this.fence.radius;
            if (!radius) {
                const zoom = this.mapCase.getZoom();
                radius = this.getZoomRadis(zoom);
            }
            let center = this.fence.center;
            if (!center || !center.length) {
                center = this.fence.mapCenter;
            }
            this.circle = new AMap.Circle({
                center: new AMap.LngLat(center[0], center[1]),
                radius, // 圆半径
                borderWeight: 3,
                strokeColor: "#3697FF",
                // strokeOpacity: 0.2,
                strokeWeight: 2,
                strokeStyle: 'dashed',
                // strokeDasharray: [10, 10],
                strokeStyle: 'solid',
                fillColor: '#36A2FF',
                fillOpacity: 0.2,
                zIndex: 50
            });
            this.mapCase.add(this.circle);
            this.circleCase = new AMap.CircleEditor(this.mapCase, this.circle);
            this.circleCase.open();
            if (this.fence.zoom) {
                this.mapCase.setZoomAndCenter(this.fence.zoom, this.fence.mapCenter, true);
            } else {
                this.mapCase.setFitView([this.circle], true);
            }
        },
        // 地图
        initMap() {
            AMapLoader.load({
                'key': this.amapKey,
                'version': '2.0',
                'plugins': ['AMap.Polygon', 'AMap.PolygonEditor', 'AMap.Circle', 'AMap.CircleEditor', 'AMap.AutoComplete', 'AMap.PlaceSearch']
            }).then((AMap) => {
                this.AMap = AMap;
                const map = this.$refs.map;
                this.mapCase = new AMap.Map(map, {
                    zoom: 14,
                });
                this.mapCase.getCity(res => {
                    // const city = res.citycode;
                    this.autoCompleteCase = new AMap.AutoComplete();
                    this.placeSearchCase = new AMap.PlaceSearch({
                        map: this.mapCase
                    });
                });
                if (this.value && (this.value.path || this.value.radius)) {
                    this.fence = lodash.cloneDeep(this.value);
                    this.doDraw();
                }
            });
        },
        getZoomRadis(zoome) {
            const zoom = parseInt(zoome);
            if (zoom >= 14) {
                return 1000;
            } else if (zoom === 13) {
                return 3000;
            } else if (zoom === 12) {
                return 5000;
            } else if (zoom === 11) {
                return 10000;
            } else if (zoom === 10) {
                return 20000;
            } else if (zoom === 9) {
                return 40000;
            } else if (zoom === 8) {
                return 80000;
            } else if (zoom === 7) {
                return 160000;
            } else if (zoom === 6) {
                return 320000;
            }
            return 640000;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
    line-height: inherit;
    font-size: inherit;
}

.box {
    height: 100%;
    position: relative;

    .map {
        height: calc(90vh - 50px);
    }
}

.layer {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    padding: 10px 15px 10px 0;
    background: #ffffff;
    box-shadow: 0 2px 6px 0 #d2d2d2;
    border-radius: 4px;
    display: flex;
    align-items: center;

    :deep(.el-input__inner) {
        border: none;
    }
}

::v-deep .el-autocomplete-suggestion li {
    padding-top: 10px;
    padding-bottom: 10px;
}

:deep(.amap-logo) {
    display: none !important;
}

:deep(.amap-copyright) {
    display: none !important;
}
</style>
